import { Avatar, AvatarGroup } from "@mui/material";
import { useTranslations } from "use-intl";

type Airline = {
  name: string;
  logoUrl: string;
};

type Props = {
  airlines: Airline[];
};

function AirlineAvatarGroup({ airlines }: Props) {
  const t = useTranslations();

  return (
    <AvatarGroup>
      {airlines.map((airline) => (
        <Avatar
          key={airline.name}
          alt={t("flights.airlineLogoAlt", { airline: airline.name })}
          sx={{
            width: 24,
            height: 24,
          }}
          src={airline.logoUrl}
        >
          {airline.name?.charAt(0) || ""}
        </Avatar>
      ))}
    </AvatarGroup>
  );
}

export default AirlineAvatarGroup;
